<template>
    <header class="w-full flex items-center justify-between md:justify-end">

        <button @click="openMenu" ref="menu-button" class="p-1 block md:hidden rounded text-gray-500 hover:text-gray-600 focus:outline-none focus:shadow-outline">
            <icon-svg icon="menu" class="w-4 transition duration-150"/>
        </button>

        <main-dropdown/>
        
    </header>
</template>

<script>
import MainDropdown from './MainDropdown'
export default {
    name: 'MainHeader',
    components: {
        MainDropdown
    },
    methods: {
        openMenu () {
            this.$refs['menu-button'].blur();
            this.$emit('toggle-sidebar');
        }
    },
}
</script>